/**
 * Look of a home-page `ROW` widget, driven by the backend widget config.
 * Every field is optional; anything missing or malformed falls back to the
 * defaults below, so a bad value from the server can never crash the home
 * page or render an invisible tile.
 */
export interface RowWidgetThemeInput {
  badge_text?: unknown;
  bg_color?: unknown;
  text_color?: unknown;
  badge_bg_color?: unknown;
}

export interface RowWidgetTheme {
  /** Empty string = no badge. */
  badgeText: string;
  bgColor: string;
  textColor: string;
  badgeBgColor: string;
}

export const ROW_WIDGET_DEFAULTS: RowWidgetTheme = {
  badgeText: "ATT",
  bgColor: "#E3183C",
  textColor: "#FFFFFF",
  badgeBgColor: "rgba(255,255,255,0.22)",
};

const HEX = /^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const RGB =
  /^rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*(?:,\s*(?:0|1|0?\.\d+)\s*)?\)$/i;

export const isSafeColor = (value: unknown): value is string =>
  typeof value === "string" &&
  (HEX.test(value.trim()) || RGB.test(value.trim()));

const color = (value: unknown, fallback: string): string =>
  isSafeColor(value) ? value.trim() : fallback;

const MAX_BADGE_CHARS = 4;

export const resolveRowWidgetTheme = (
  item?: RowWidgetThemeInput | null,
): RowWidgetTheme => {
  const badge = item?.badge_text;
  return {
    badgeText:
      typeof badge === "string"
        ? badge.trim().slice(0, MAX_BADGE_CHARS)
        : ROW_WIDGET_DEFAULTS.badgeText,
    bgColor: color(item?.bg_color, ROW_WIDGET_DEFAULTS.bgColor),
    textColor: color(item?.text_color, ROW_WIDGET_DEFAULTS.textColor),
    badgeBgColor: color(item?.badge_bg_color, ROW_WIDGET_DEFAULTS.badgeBgColor),
  };
};
